import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProductCard from "../../Components/ProductCard";
import './Row.css';

function Row({ title, subtitle, products, buttonText, category }) {
    const navigate = useNavigate();
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    // Limit to first 3 products
    const displayProducts = products.slice(0, 3);

    useEffect(() => {
        const el = sectionRef.current;
        // Animate in when the section scrolls into view…
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
        );
        if (el) observer.observe(el);

        // …but never leave the products hidden: reveal shortly after mount
        // as a fallback in case the observer doesn't fire.
        const fallback = setTimeout(() => setIsVisible(true), 400);

        return () => {
            if (el) observer.unobserve(el);
            clearTimeout(fallback);
        };
    }, []);

    const handleExploreClick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        setTimeout(() => {
            // Use dynamic routing based on category
            if (category) {
                navigate(`/category/${category}`);
            }
        }, 300);
    };

    return (
        <div 
            ref={sectionRef}
            className={`product-row-section ${isVisible ? 'animate-in' : ''}`}
        >
            <div className="row-header">
                <h2 className={`row-title ${isVisible ? 'title-animate' : ''}`}>
                    {title}
                </h2>
                {subtitle && (
                    <p className={`row-subtitle ${isVisible ? 'subtitle-animate' : ''}`}>
                        {subtitle}
                    </p>
                )}
            </div>
            
            <div className={`products-grid ${isVisible ? 'grid-animate' : ''}`}>
                {displayProducts.map((product, index) => (
                    <div 
                        key={index}
                        className={`product-card-wrapper ${isVisible ? 'card-animate' : ''}`}
                        style={{ animationDelay: `${index * 0.1}s` }}
                    >
                        <ProductCard cookie={product} />
                    </div>
                ))}
            </div>
            
            <div className="row-footer">
                <button 
                    className={`explore-more-btn ${isVisible ? 'button-animate' : ''}`}
                    onClick={handleExploreClick}
                >
                    {buttonText}
                </button>
            </div>
        </div>
    );
}

export default Row;